import React from 'react';
import moment from 'moment';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';

import {AutocompleteInput, DateInput, ReferenceInput, required, Title,} from 'react-admin';

import {downloadFile, NotifyForm, schoolYears, TreeCheckboxInput,} from '../../components';
import env from '../../env';
import {downloadFilePost} from '../../components/FileDownload';

const DeptStudentsReport = (props) => {
    const [changeSchoolYear, setChangeSchoolYear] = React.useState(false);
    const [unitIds, setUnitIds] = React.useState([]);
    const [schoolYearId, setSchoolYearId] = React.useState(schoolYears[0]?.id);
    const [asOfDate, setAsOfDate] = React.useState(moment().format('YYYY-MM-DD'));
    const [fromBatchDate, setFromBatchDate] = React.useState(moment().format('YYYY-MM-DD'));
    const [toBatchDate, setToBatchDate] = React.useState(moment().format('YYYY-MM-DD'));


    const params = React.useMemo(
        () => ({
            changeSchoolYear,
            unitIds,
            schoolYearId,
            asOfDate,
            fromBatchDate,
            toBatchDate,
        }),
        [changeSchoolYear, unitIds, schoolYearId, asOfDate, fromBatchDate, toBatchDate]
    );

    const inDeptAllClassType = React.useCallback(() => {
        downloadFilePost(`${env.reportURL}/reports/payments/studentsInDept`, 'bc_HS_chua_dong_hoc_phi.xlsx', {
            schoolYearId,
            asOfDate,
            fromBatchDate,
            toBatchDate,
            unitIds,
            fullDayOnly: false,
        });
    }, [schoolYearId, asOfDate, fromBatchDate, toBatchDate, unitIds]);

    const fullDayOnly = React.useCallback(() => {
        downloadFilePost(`${env.reportURL}/reports/payments/studentsInDept`, 'bc_HS_chua_dong_hoc_phi.xlsx', {
            schoolYearId,
            asOfDate,
            fromBatchDate,
            toBatchDate,
            unitIds,
            fullDayOnly: true,
        });
    }, [schoolYearId, asOfDate, fromBatchDate, toBatchDate, unitIds]);

    // validate của NotifyForm
    const validate = React.useCallback(
        (values) => {
            const errors = {};
            if (values.fromBatchDate && values.toBatchDate && values.fromBatchDate > values.toBatchDate) {
                errors.toBatchDate = 'To date must be greater than From date';
            }

            // Đồng bộ state từ form values
            if (typeof values.fromBatchDate !== 'undefined') setFromBatchDate(values.fromBatchDate);
            if (typeof values.toBatchDate !== 'undefined') setToBatchDate(values.toBatchDate);
            if (typeof values.asOfDate !== 'undefined') setAsOfDate(values.asOfDate);

            // Reset unitIds nếu vừa đổi năm học
            if (changeSchoolYear) {
                setUnitIds([]);
                setChangeSchoolYear(false);
            } else if (typeof values.unitIds !== 'undefined') {
                setUnitIds(values.unitIds);
            }

            return errors;
        },
        [changeSchoolYear]
    );

    const onSchoolYearChanged = React.useCallback((_e, value) => {
        setSchoolYearId(value);
        setChangeSchoolYear(true);
    }, []);

    return (
      <Card>
        <Title title="resources.deptStudentsReport.name" />
        <CardContent>
            <div>
                Báo cáo danh sách học sinh chưa đóng tiền theo kế hoạch: ngày bắt đầu kế hoạch trong khoảng thời gian
                được chọn
          </div>

            <NotifyForm
                params={params}
                validate={validate}
                allClazzes={inDeptAllClassType}
                fullDayClazzes={fullDayOnly}
          >
            <Grid container spacing={8}>
                <Grid item xs={12} sm={6}>
                    <DateInput
                        label="resources.deptStudentsReport.fromBatchDate"
                        source="fromBatchDate"
                        validate={required()}
                        {...props}
                    />
              </Grid>
                <Grid item xs={12} sm={6}>
                    <DateInput
                        label="resources.deptStudentsReport.toBatchDate"
                        source="toBatchDate"
                        validate={required()}
                        {...props}
                    />
              </Grid>
                <Grid item xs={12} sm={6}>
                    <DateInput
                        label="resources.deptStudentsReport.asOfDate"
                        source="asOfDate"
                        validate={required()}
                        {...props}
                    />
                    <span style={{marginLeft: 8}}>(đến 23:59:59) của ngày được chọn</span>
                </Grid>
                <Grid item xs={12} sm={6}>
                </Grid>

              <Grid container spacing={8}>
                <Grid item xs={12} sm={6}>
                    <ReferenceInput
                        source="schoolYearId"
                        reference="schoolYears"
                        label="resources.schoolYears.name"
                        perPage={50}
                        validate={required()}
                        onChange={onSchoolYearChanged}
                        {...props}
                    >
                    <AutocompleteInput source="name" />
                  </ReferenceInput>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <label>Danh sách lớp</label>
                    <div style={{maxHeight: '300px', overflow: 'auto'}}>
                        <ReferenceInput
                            source="unitIds"
                            reference="units"
                            perPage={999}
                            filter={{clazzWithParents: true, schoolYear: schoolYearId}}
                            {...props}
                        >
                            <TreeCheckboxInput optionValue="id" optionText="name" expandTopLevel/>
                    </ReferenceInput>
                  </div>
                </Grid>
              </Grid>
            </Grid>
          </NotifyForm>

        </CardContent>
      </Card>
    );
};

export default DeptStudentsReport;
